/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Garage_CountInputs */

const cs_form_garage_count = /** @type {(inputs: Form_Garage_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počet garáží`)
};

const en_form_garage_count = /** @type {(inputs: Form_Garage_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage spaces`)
};

/**
* | output |
* | --- |
* | "Garage spaces" |
*
* @param {Form_Garage_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_garage_count = /** @type {((inputs?: Form_Garage_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Garage_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_garage_count(inputs)
	return cs_form_garage_count(inputs)
});